import { Text } from '@etg/wings';
// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import ProductDrawerCard from '../../common/components/ProductDrawerCard';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const LoungeDrawerContent = ({
  labels,
  loungeInfo
}) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(ProductDrawerCard, {
    cardTitle: labels.loungeDrawerOpeningTitle,
    children: /*#__PURE__*/_jsxs(Text, {
      as: "p",
      children: [labels.loungeDrawerOpeningFrom, " ", /*#__PURE__*/_jsx(Text, {
        variant: "14-bold",
        children: loungeInfo.openAt
      }), ' ', labels.loungeDrawerOpeningTo, " ", /*#__PURE__*/_jsx(Text, {
        variant: "14-bold",
        children: loungeInfo.closeAt
      })]
    })
  }), loungeInfo.amenities.length > 0 && /*#__PURE__*/_jsx(ProductDrawerCard, {
    cardTitle: labels.loungeDrawerAmenities,
    children: /*#__PURE__*/_jsx("ul", {
      children: loungeInfo.amenities.map(amenity => {
        var _amenity$code;
        return /*#__PURE__*/_jsx("li", {
          children: amenity.name
        }, (_amenity$code = amenity.code) !== null && _amenity$code !== void 0 ? _amenity$code : amenity.id);
      })
    })
  }), /*#__PURE__*/_jsx(ProductDrawerCard, {
    cardTitle: labels.loungeDrawerLocation,
    children: /*#__PURE__*/_jsxs(Text, {
      children: [labels.loungeDrawerTerminal, " ", loungeInfo.terminal]
    })
  }), loungeInfo.conditions.length > 0 && /*#__PURE__*/_jsx(ProductDrawerCard, {
    cardTitle: labels.loungeDrawerCondition,
    children: loungeInfo.conditions.map(item => /*#__PURE__*/_jsx(Text, {
      children: item.description
    }, item.code))
  })]
});
export default LoungeDrawerContent;
//# sourceMappingURL=LoungeDrawerContent.js.map